import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { EmployerUsesAutoUXOption } from "../../types/Dossier";

type RequestEmployerSetupPayload = {
  employerName: string;
  employerUsesAutoUX: EmployerUsesAutoUXOption;
  firstName?: string;
  lastName?: string;
  jobTitle?: string;
  email?: string;
  mobile?: string;
};

export const requestEmployerAccountSetup = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();
  const invalidateList = [
    ["user"],
    ["dossier", dossierId],
    ["dossierStatus", dossierId],
  ];

  return useMutation({
    mutationFn: (payload: RequestEmployerSetupPayload): Promise<string> => {
      return fetchWithAuth<string>("requestEmployerAccountSetup", dossierId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () => defaultOnMutateSettled(invalidateList),
  });
};
